

import {defineComponent} from "vue";
import IonPage from "@/App.vue";

export default defineComponent({
  name: "Demo",
  components: {IonPage}
})
